import { useContext, useEffect } from "react";
import { ImpresionContext } from "../../providers/Impresion";
import SideBar from "./SideBar";
import UseTemplate from "./UseTemplate";
import { toast } from 'react-toastify';

const TemplateSideBar = ({ onClose, evento, tarifa }) => {
  const {
    plantillasUsuario,
    loadingPlantillas,
    cargarPlantillasUsuario,
    eliminarPlantilla
  } = useContext(ImpresionContext);

  useEffect(() => {
    cargarPlantillasUsuario();
  }, []);

  const handleEliminarPlantilla = async (id, nombre) => {
    if (window.confirm(`¿Estás seguro de eliminar la plantilla "${nombre}"?`)) {
      const result = await eliminarPlantilla(id);
      if (result.success) {
        toast.success("PLantilla eliminada correctamente");
      } else {

        toast.error("Error al eliminar la plantilla: " + result.message, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    }
  };

  return (
    <SideBar id='templateBar'>
      <div className='d-flex flex-column'>
        <div className="w-100 d-flex justify-content-between align-items-center">
          <div>
            <p className="p-0 m-0 fs-4">Plantillas</p>
          </div>
          <div>
            <button className="d-flex align-items-center" onClick={() => onClose()}>
              <i className="material-symbols-outlined">close</i>
            </button>
          </div>
        </div>

        {/* PREDETERMINADAS */}
        <div>
          <p className="m-0 p-0 fs-5">Recomendaciones</p>
        </div>
        <div className='w-100 d-flex flex-column gap-1'>
          <UseTemplate template={'pulsera'} evento={evento} tarifa={tarifa}>
            Plantilla de Pulsera
          </UseTemplate>
          <UseTemplate template={'tarjeta'} evento={evento} tarifa={tarifa}>
            Plantilla de Tarjeta
          </UseTemplate>
          {/* <UseTemplate template={'voucher'}>Plantilla de Voucher</UseTemplate> */}
        </div>

        {/* PERSONALIZADAS */}
        <div style={{ marginTop: '1rem' }}>
          <p className="m-0 p-0 fs-5">Mis Plantillas</p>
        </div>
        <div className='w-100 d-flex flex-column gap-1'>
          {loadingPlantillas ? (
            <div className="d-flex justify-content-center p-2">
              <div className="spinner-border spinner-border-sm" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          ) : plantillasUsuario.length > 0 ? (
            plantillasUsuario.map((plantilla) => (
              <UseTemplate
                key={plantilla.id}
                plantillaData={plantilla}
                evento={evento}
                tarifa={tarifa}
                onEliminar={() => handleEliminarPlantilla(plantilla.id, plantilla.nombre)}
              >
                {plantilla.nombre}
              </UseTemplate>
            ))
          ) : (
            <p className="text-muted small p-2 m-0">
              No tienes plantillas guardadas aún
            </p>
          )}
        </div>
      </div>
    </SideBar>
  );
};

export default TemplateSideBar;